// JavaScript Document
//components/signs/sign.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
//import ButtonGroup from '@material-ui/core/ButtonGroup';
//import ButtonBase from '@material-ui/core/ButtonBase';
import TextField from '@material-ui/core/TextField';
//import Map from './Map';
//import Map from '../../map/Map';
//import SingleMap from '../../map/SingleMap';
import SendIcon from '@material-ui/icons/Send';
import RevertIcon from '@material-ui/icons/History';
import Alert from '@material-ui/lab/Alert';
import Tooltip from '@material-ui/core/Tooltip';
//import ImagePicker from './ImagePicker';
//import Option from '../option/View';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
	//backgroundColor: theme.palette.background.paper
  },
	formCard : {
		marginBottom: theme.spacing(3),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap:"wrap"
	},
  paper: {
    padding: theme.spacing(2),
    margin: 'auto'
  },
  signTypeItem : {
	  backgroundSize:'contain', 
	  backgroundRepeat:'no-repeat', 
	  backgroundPosition:'center',	
	  textAlign:'center',
  },

}));

const error_text = {
	'ICM_ERROR_ONE':'Unable to connect to sign while trying to send Instant Critical Message.  The sign is still in normal operation.',
	'ICM_ERROR_TWO':'Unable to connect to sign. Sign is still displaying the Instant Critical Message below.',
};




export default function SignBasic(props) {
	const classes = useStyles();
	const {handleSend, sign, onChange} = props;
	const [signId, setSignId] = React.useState(0);
	const [icmError, setIcmError] = React.useState('');
	const [message, setMessage] = React.useState(['', '']);
	const [changed, setChanged] = React.useState(false);
	const [sendLabel, setSendLabel] = React.useState('Send');
	const [showReturn, setShowReturn] = React.useState(false);

	
	React.useEffect(() => {
		if(sign && sign.id !== signId){
			setSignId(sign.id);
			handleParseICM(sign.amberAlert);
			/*
			if(sign.amberAlert){
				var udisplay = sign.amberAlert.substring(0, 5).trim();
				var ldisplay = sign.amberAlert.substring(5, 5).trim();
				setMessage([udisplay, ldisplay]);
				var ems = sign.amberAlert.substring(10);
				if(ems === 'EA'){
					setIcmError('ICM_ERROR_ONE');
				} else if(ems === 'ER'){
					setIcmError('ICM_ERROR_TWO');
				} else {
					setIcmError('');
				}
				setShowReturn(true);
			}
			*/
		}
	   // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	
	//handle parse amber alert
	const handleParseICM = (icm) => {
		if(icm){
			let sr = true;
			var udisplay = icm.substring(0, 5).trim();
			var ldisplay = icm.substring(5, 10).trim();
			console.log([udisplay, ldisplay]);
			var ems = icm.substring(10);
			setMessage([udisplay, ldisplay]);
			if(ems === 'EA'){
				setIcmError('ICM_ERROR_ONE');
				sr = false;
			} else if(ems === 'ER'){
				setIcmError('ICM_ERROR_TWO');
			} else {
				setIcmError('');
			}
			setShowReturn(sr);
		} else {
			setShowReturn(false);
			setIcmError('');
			setMessage(['', '']);
		}
	}
	
	
	//handle change any value
	const handleChangeValue = (e) => {
		let name = e.target.name;
		let value = e.target.value
		//let newDetails = Object.assign({}, datas);
		if(name === 'udisplay'){
			setMessage([value, message[1]]);
		} else if(name === 'ldisplay'){
			setMessage([message[0], value]);
		}
		
		
		
		//newDetails[name] = value;
		//setDatas(newDetails);
		//if(onChange){
		//	onChange(newDetails);
		//}
		setChanged(true);
	}
	
	const handleSendMessage = () => {
		//disable button
		setSendLabel('Sending');
		var mySign = Object.assign({}, sign);
		mySign.amberAlert = message[0].padStart(5, " ")+message[1].padStart(5, " ");
		handleSend({
			vso: 'sign',
			sign: mySign,
			amberAlert: {
				type: 'send',
				message: mySign.amberAlert
			},
			subaction: 'amberAlert'
		}, (data) => {
			console.log(data);
			//setUserChanged(false);
			setChanged(false);
			setSendLabel('Send');
			handleParseICM(data.sign.amberAlert);
			if(onChange){
				console.log('somethings changed!');
				onChange(data.sign);
			}
			//setConfig(data.config);
			
		});
		//update local vars
		//setChanged(false);
	}
	
	const handleSendReturn = () => {
		setSendLabel('Sending');
		var mySign = Object.assign({}, sign);
		mySign.amberAlert = '';
		handleSend({
			vso: 'sign',
			sign: mySign,
			amberAlert: {
				type: 'return'
			},
			subaction: 'amberAlert'
		}, (data) => {
			console.log(data);
			setSendLabel('Send');
			handleParseICM(data.sign.amberAlert);
			if(onChange){
				console.log('somethings changed!');
				onChange(data.sign);
				
			}
		});
	}
	
	const renderSend = () => {
		if(changed || icmError === 'ICM_ERROR_ONE')
			return (
				<Tooltip title="Send message to sign" arrow>
				<Button 
					variant="contained" 
					color="secondary" 
					endIcon={<SendIcon />} 
					onClick={handleSendMessage}
					disabled={sendLabel==='Sending' ? true : false}
				>{sendLabel}</Button>
				</Tooltip>
			);
		return '';
	}
	const renderReturn = () => {
		if(showReturn || icmError === 'ICM_ERROR_TWO')
			return (
				<Tooltip title="Resume normal operation" arrow>
				<Button
					variant="contained"
					color="primary"
					endIcon={<RevertIcon />}
					onClick={handleSendReturn}
					disabled={sendLabel==='Sending' ? true: false}
				>{sendLabel === 'Sending' ? 'Sending' : 'Resume'}</Button>
				</Tooltip>
			);
		return '';
	}
	
	const renderError = () => {
		if(icmError)
			return (
				<Grid item xs={12}>
					<Alert elevation={4} variant="filled" severity="error">{error_text[icmError]}</Alert>
				</Grid>
			);
		return '';
	}
	
	
	return (
		<Card className={classes.root}>
			<CardHeader title="Instant Critical Message" action={[renderSend(), renderReturn()]} />
	  		<CardContent>
				<Grid container spacing={3}>
					{renderError()}
					<Grid item xs={12} sm={6}>
						<TextField
							id="icm_upper"
							name="udisplay"
							label="First Row"
							value={message[0]}
							type="text"
							inputProps = {{
									  maxlength:"5"
									 }}
							onChange={handleChangeValue}
							fullWidth
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextField
							id="icm_lower"
							name="ldisplay"
							label="Second Row"
							value={message[1]}
							type="text"
							inputProps = {{
									  maxlength:"5"
									 }}
							onChange={handleChangeValue}
							fullWidth
						/>
					</Grid>
				</Grid>
	  		</CardContent>
	  	</Card>
	);
}
